import BaseService from '../../BaseService.js';

export default class WohnungenService extends BaseService {

  constructor(wohnobjektId) {
    super(`wohnobjekte/${wohnobjektId}/wohnungen`)
  }
}
